export default __webpack_public_path__ + "static/media/Spiritual-Gifts-Logo.90a1e3cf.svg";